import React from "react";

const Alert = ({ type, message, show, onClose, className = "" }) => {
  if (!show) return null;

  const bootstrapType = {
    success: "alert-success",
    error: "alert-danger",
    warning: "alert-warning",
    info: "alert-info",
  };

  return (
    <div
      className={`alert alert--${type} alert ${bootstrapType[type]} alert-dismissible fade show ${className}`}
    >
      <div className="alert__content">
        <span className="alert__message">{message}</span>
        <button
          type="button"
          className="alert__close btn-close"
          onClick={onClose}
          aria-label="Close"
        ></button>
      </div>
    </div>
  );
};

export default Alert;
